var render, staticRenderFns
import script from "./powerConsumption.vue?vue&type=script&lang=js&"
export * from "./powerConsumption.vue?vue&type=script&lang=js&"
import style0 from "./powerConsumption.vue?vue&type=style&index=0&id=4f54b190&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54b190",
  null
  
)

export default component.exports